/* Mila Video-Testimonials
   Kacheln: stummer Preview-Loop (nur erste N Sekunden, preload=metadata -> minimaler Traffic)
   Klick: Overlay (dialog) laedt das volle Video mit Ton + Controls */
function initMilaVideoTestimonials(root){
  if (!root || root.dataset.mvtInit === '1') return;
  root.dataset.mvtInit = '1';

  var previewSec = parseFloat(root.dataset.previewSeconds || '5') || 5;
  var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-mvt-tile]'));
  var track = root.querySelector('[data-mvt-track]');
  var popup = root.querySelector('[data-mvt-popup]');
  var popupMedia = root.querySelector('[data-mvt-popup-media]');
  var btnClose = root.querySelector('[data-mvt-close]');
  var btnPrev = root.querySelector('[data-mvt-prev]');
  var btnNext = root.querySelector('[data-mvt-next]');
  if (!tiles.length || !popup) return;

  /* --- Preview-Loop: nur die ersten N Sekunden, stumm --- */
  tiles.forEach(function(tile){
    var v = tile.querySelector('video');
    if (!v) return;
    v.muted = true;
    v.addEventListener('timeupdate', function(){
      if (v.currentTime >= previewSec) {
        v.currentTime = 0.01;
        var p = v.play(); if (p && p.catch) p.catch(function(){});
      }
    });
    v.addEventListener('ended', function(){
      v.currentTime = 0.01;
      var p = v.play(); if (p && p.catch) p.catch(function(){});
    });
  });

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var v = en.target.querySelector('video');
        if (!v) return;
        if (en.isIntersecting && popupOpenIdx === -1) {
          var p = v.play(); if (p && p.catch) p.catch(function(){});
        } else {
          v.pause();
        }
      });
    }, {threshold: 0.4});
    tiles.forEach(function(t){ io.observe(t); });
  }

  function pausePreviews(){ tiles.forEach(function(t){ var v=t.querySelector('video'); if(v) v.pause(); }); }
  function resumePreviews(){
    tiles.forEach(function(t){
      var v = t.querySelector('video');
      if (!v) return;
      var r = t.getBoundingClientRect();
      if (r.right > 0 && r.left < window.innerWidth) {
        var p = v.play(); if (p && p.catch) p.catch(function(){});
      }
    });
  }

  /* --- Overlay --- */
  var popupOpenIdx = -1;
  var popupVideo = null;

  function ensurePopupVideo(){
    if (popupVideo) return popupVideo;
    popupVideo = document.createElement('video');
    popupVideo.setAttribute('controls', 'controls');
    popupVideo.setAttribute('playsinline', 'playsinline');
    popupVideo.loop = true;
    popupMedia.appendChild(popupVideo);
    return popupVideo;
  }

  function openPopup(i){
    if (i < 0 || i >= tiles.length) return;
    popupOpenIdx = i;
    var tile = tiles[i];
    var v = ensurePopupVideo();
    v.poster = tile.dataset.poster || '';
    v.src = tile.dataset.fullSrc || '';
    v.muted = false;
    pausePreviews();
    if (!popup.open) popup.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (btnPrev) btnPrev.disabled = i === 0;
    if (btnNext) btnNext.disabled = i === tiles.length - 1;
    var p = v.play(); if (p && p.catch) p.catch(function(){});
  }

  function closePopup(){
    if (popupVideo) { popupVideo.pause(); popupVideo.removeAttribute('src'); popupVideo.load(); }
    if (popup.open) popup.close();
    popupOpenIdx = -1;
    document.documentElement.style.overflow = '';
    resumePreviews();
  }

  tiles.forEach(function(tile, i){
    tile.addEventListener('click', function(){ openPopup(i); });
  });
  if (btnClose) btnClose.addEventListener('click', closePopup);
  if (btnPrev) btnPrev.addEventListener('click', function(){ openPopup(popupOpenIdx - 1); });
  if (btnNext) btnNext.addEventListener('click', function(){ openPopup(popupOpenIdx + 1); });
  popup.addEventListener('cancel', function(){ closePopup(); });
  popup.addEventListener('click', function(e){
    if (e.target === popup) closePopup();
  });

  /* --- Maus-Drag auf der Kachel-Reihe (Desktop) --- */
  if (track) {
    var drag = {active:false, moved:false, startX:0, startScroll:0};
    track.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag.active = true; drag.moved = false;
      drag.startX = e.clientX; drag.startScroll = track.scrollLeft;
    });
    window.addEventListener('pointermove', function(e){
      if (!drag.active) return;
      var dx = e.clientX - drag.startX;
      if (!drag.moved && Math.abs(dx) > 8) { drag.moved = true; track.classList.add('is-dragging'); }
      if (drag.moved) track.scrollLeft = drag.startScroll - dx;
    });
    window.addEventListener('pointerup', function(){
      if (!drag.active) return;
      if (drag.moved) {
        track.classList.remove('is-dragging');
        track._suppress = true;
        setTimeout(function(){ track._suppress = false; }, 80);
      }
      drag.active = false;
    });
    track.addEventListener('click', function(e){
      if (track._suppress) { e.stopPropagation(); e.preventDefault(); }
    }, true);
  }
}

(function(){
  function initAll(){
    document.querySelectorAll('[data-mvt]').forEach(initMilaVideoTestimonials);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
